module.exports = __webpack_public_path__ + "312ca6b878591e683683f7a021a5969f.png";